
  import ConversationParticipants from "@/entities/ConversationParticipants";
  import { User_Conversation} from "@/generated/graphql";

  export default function getConversationParticipants(
    users: User_Conversation[], 
    currentUserId: string
  ): ConversationParticipants | undefined {
    if (!users) {
      return undefined;
    }
    const participantsToFilter =  users
      .filter(
        (conversationUser) => conversationUser.user.id !== currentUserId
      )
      .map((conversationUser) => {
        return {
          id: conversationUser.user.id,
          deleted: conversationUser.deleted,
          initial: `${conversationUser.user.given_name} ${conversationUser.user.family_name}`,
          avatar: conversationUser.user.avatar,
        };
      });
    const activeParticipants = participantsToFilter.filter(p => !p.deleted );
    const deletedParticipants = participantsToFilter.filter(p => p.deleted);
    return {
      all: [...activeParticipants, ...deletedParticipants],
      active: activeParticipants,
    };
  }